import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'farm',
  setup(__props) {

const router: any = useRouter()

const $route: any = useRoute()

const { VUE_APP_ENV } = process.env

const baseUrl =
  VUE_APP_ENV === 'production'
    ? 'https://tianshu.wstaiot.com/park-screen'
    : 'http://192.168.180.201/tianshu-platform/park-screen'

onMounted(() => {
  window.open(baseUrl)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})